import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Sidebar from "./components/Sidebar";
import ProtectedRoute from "./components/ProtectedRoute";
import React, { useEffect, useState } from "react";
import "./App.css";

import ChangePasswordModal from "./pages/Auth/ChangePasswordModal";

import Dashboard from "./pages/Dashboard";
import PurchaseOrders from "./pages/POS/PurchaseOrders";
import Items from "./pages/AddItem/Item";
import Suppliers from "./pages/AddSupplier/Supplier";
import ReceivingPO from "./pages/POS/ReceivingPO";
import SalesOrders from "./pages/SO/SalesOrders";
import Warehouse from "./pages/AddWarehouse/Warehouse";
import StockReceiving from "./pages/Stock/StockReceiving";
import StockList from "./pages/Stock/StockList";
// import Machines from "./pages/AddMachine/Machine";
// import MachineSuppliers from "./pages/AddMachineSupplier/MachineSupplier";
import Customers from "./pages/Customers/Customers";
// import StockOut from "./pages/Stock/StockOut";
import StockTransactions from "./pages/Stock/StockTransactions";
import SalesPersons from "./pages/SalesPerson/SalesPerson";
import SalesOrdersLogistics from "./pages/SO/SalesOrdersLogistics";
import DeliveryNotes from "./pages/DeliveryNotes/DeliveryNotes";
import Login from "./pages/Login/Login";
import OpeningStock from "./pages/Stock/OpeningStock";
import StockTransfer from "./pages/StockTransfer/StockTransfer";
import DnEditPrint from "./pages/DeliveryNotes/DnEditPrint";
import Reports from "./pages/Reports/Reports";
import ManualStockOutPage from "./pages/Stock/ManualStockOut";
import CreateUser from "./pages/Users/CreateUser";

import BarcodeInformation from "./pages/Stock/BarcodeInformation";

/* =====================================
   LAYOUT HANDLER
===================================== */
function Layout({ children }) {
  const location = useLocation();
  const isLoginPage = location.pathname === "/login";

  const [showChangePassword, setShowChangePassword] = useState(false);

  useEffect(() => {
    if (isLoginPage) return;

    const user = JSON.parse(localStorage.getItem("user") || "{}");
    setShowChangePassword(Number(user.MustChangePassword) === 1);
  }, [isLoginPage, location.pathname]);

  return (
    <div className={`app-layout ${isLoginPage ? "login-layout" : ""}`}>
      {!isLoginPage && <Sidebar />}

      <main className="app-main">
        {children}

        {showChangePassword && (
          <ChangePasswordModal onSuccess={() => setShowChangePassword(false)} />
        )}
      </main>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          {/* PUBLIC */}
          <Route path="/login" element={<Login />} />

          {/* PROTECTED */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />

          <Route
            path="/po"
            element={
              <ProtectedRoute>
                <PurchaseOrders />
              </ProtectedRoute>
            }
          />

          <Route
            path="/items"
            element={
              <ProtectedRoute>
                <Items />
              </ProtectedRoute>
            }
          />

          <Route
            path="/suppliers"
            element={
              <ProtectedRoute>
                <Suppliers />
              </ProtectedRoute>
            }
          />

          <Route
            path="/warehouse"
            element={
              <ProtectedRoute>
                <Warehouse />
              </ProtectedRoute>
            }
          />

          <Route
            path="/receiving-po"
            element={
              <ProtectedRoute>
                <ReceivingPO />
              </ProtectedRoute>
            }
          />

          <Route
            path="/users"
            element={
              <ProtectedRoute>
                <CreateUser />
              </ProtectedRoute>
            }
          />

          {/* STOCK */}
          <Route
            path="/stock-receiving"
            element={
              <ProtectedRoute>
                <StockReceiving />
              </ProtectedRoute>
            }
          />

          <Route
            path="/stock-list"
            element={
              <ProtectedRoute>
                <StockList />
              </ProtectedRoute>
            }
          />

          {/* <Route path="/stock-out" element={<ProtectedRoute><StockOut /></ProtectedRoute>} /> */}

          <Route
            path="/stock-transaction"
            element={
              <ProtectedRoute>
                <StockTransactions />
              </ProtectedRoute>
            }
          />

          <Route
            path="/opening-stock"
            element={
              <ProtectedRoute>
                <OpeningStock />
              </ProtectedRoute>
            }
          />

          <Route
            path="/manual-stock-out"
            element={
              <ProtectedRoute>
                <ManualStockOutPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/stock-transfer"
            element={
              <ProtectedRoute>
                <StockTransfer />
              </ProtectedRoute>
            }
          />

          <Route
            path="/barcode-information"
            element={
              <ProtectedRoute>
                <BarcodeInformation />
              </ProtectedRoute>
            }
          />

          {/* MACHINES */}
          {/* 
          <Route
            path="/machines"
            element={
              <ProtectedRoute>
                <Machines />
              </ProtectedRoute>
            }
          />

          <Route
            path="/machine-suppliers"
            element={
              <ProtectedRoute>
                <MachineSuppliers />
              </ProtectedRoute>
            }
          />
          */}

          {/* SALES */}
          <Route
            path="/customers"
            element={
              <ProtectedRoute>
                <Customers />
              </ProtectedRoute>
            }
          />

          <Route
            path="/sales-person"
            element={
              <ProtectedRoute>
                <SalesPersons />
              </ProtectedRoute>
            }
          />

          <Route
            path="/so"
            element={
              <ProtectedRoute>
                <SalesOrders />
              </ProtectedRoute>
            }
          />

          <Route
            path="/sales-orders-logistics"
            element={
              <ProtectedRoute>
                <SalesOrdersLogistics />
              </ProtectedRoute>
            }
          />

          <Route
            path="/delivery-notes"
            element={
              <ProtectedRoute>
                <DeliveryNotes />
              </ProtectedRoute>
            }
          />

          <Route
            path="/delivery-notes/:dnid/print-edit"
            element={
              <ProtectedRoute>
                <DnEditPrint />
              </ProtectedRoute>
            }
          />

          <Route
            path="/reports"
            element={
              <ProtectedRoute>
                <Reports />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;